import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetCreateFreeOrderRequestType,
  GetCreateFreeOrderResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseCreateFreeOrderInterface {
  createFreeOrderApi: UseMutateAsyncFunction<
    GetCreateFreeOrderResponseType,
    unknown,
    GetCreateFreeOrderRequestType,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useCreateFreeOrder = (): UseCreateFreeOrderInterface => {
  const { paymentServices } = usePaymentServices();

  const createFreeOrder = (requestObject: GetCreateFreeOrderRequestType) => {
    return paymentServices.createZeroAmountOrder(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(createFreeOrder, {
    mutationKey: ['createFreeOrderApi']
  });

  return {
    createFreeOrderApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useCreateFreeOrder };
